import { createApp } from 'vue'
import App from './App.vue'
import { registerPlugins } from './providers'
import { setupErrorHandler } from '@/shared/lib'
import { configureHttpClient } from '@/shared/api/http'
import { useAuthStore } from '@/features/auth'
import { fetchMe, SESSION_QUERY_KEY } from '@/entities/session'
import { queryClient } from '@/shared/api'
import { router } from './router'
import './styles/index.css'

export async function initApp() {
  const app = createApp(App)
  registerPlugins(app)
  setupErrorHandler(app)

  initializeAuth()

  return app
}

function initializeAuth(): void {
  const authStore = useAuthStore()
  const hasValidToken = authStore.initializeFromStorage()

  configureHttpClient({
    getAccessToken: () => authStore.accessToken,
    onAuthFailure: () => {
      authStore.clearAuth()
      router.push('/auth/login')
    },
  })

  if (!hasValidToken) return

  queryClient.prefetchQuery({ queryKey: SESSION_QUERY_KEY, queryFn: fetchMe })
}
